import React from 'react'
import styled from 'styled-components'
import { Box, Stack, Progress } from '@/components/lib'

import Logo from '../../images/logo/logo_light.png'

const IntroLogo = styled.img`
  @keyframes fadeIn {
    from {
      opacity: 0;
      top: -20px;
    }
    to {
      opacity: 1;
      top: 0;
    }
  }
  position: relative;
  width: 200px;
  animation: fadeIn 1.5s ease-in-out;
  filter: drop-shadow(10px 10px 15px rgba(0, 0, 0, 0.4));
`

export default function EntryContainer ({ children, asLoader }) {
  return (
    <Box minH='100vh' display='flex' justifyContent='center' pt={20} pb={20} bgGradient='to-br' gradientFrom='primary.300' gradientTo='primary.600'>
      <Stack alignItems='center' spacing={10}>
        <IntroLogo src={Logo} alt='Trialflare' />
        {children &&
          <Box p={5} bg='bg.surface' rounded='lg' boxShadow='lg' ml={2} mr={2}>
            {children}
          </Box>}
        {asLoader && <Progress value={null} w='200px' />}
      </Stack>
    </Box>
  )
}
